import * as tslib_1 from "tslib";
import deepEqual from 'deep-equal';
import m from 'mithril';
import { View } from '../ui/view';
var Fetcher = /** @class */ (function (_super) {
    tslib_1.__extends(Fetcher, _super);
    function Fetcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.hydrated = false;
        _this.onInit = _this.load;
        _this.onBeforeUpdate = _this.load;
        return _this;
    }
    Fetcher.prototype.load = function () {
        var _this = this;
        var _a = this.attrs, _b = _a.cache, cache = _b === void 0 ? this.cache : _b, _c = _a.setCache, setCache = _c === void 0 ? function (cache) { return (_this.cache = cache); } : _c, children = _a.children, hydrate = _a.hydrate, request = tslib_1.__rest(_a, ["cache", "setCache", "children", "hydrate"]);
        if (hydrate && !this.hydrated) {
            this.data = hydrate;
            this.hydrated = true;
            setCache(request);
        }
        if (deepEqual(cache, request))
            return;
        setCache(request);
        this.isLoading = true;
        this.onRemove();
        m.request(tslib_1.__assign({}, request, { config: function (xhr) { return (_this.transport = xhr); } }))
            .then(function (data) { return (_this.data = data); })
            .catch(function (e) { return console.error((_this.error = e)); })
            .then(function () { return (_this.isLoading = false); });
    };
    Fetcher.prototype.onRemove = function () {
        if (this.transport)
            this.transport = void this.transport.abort();
    };
    Fetcher.prototype.render = function () {
        return this.children({
            isLoading: this.isLoading,
            data: this.data,
            error: this.error
        });
    };
    return Fetcher;
}(View));
export { Fetcher };
